//
//
//
//
//
//

import xregister from "../components/xregister.vue"
export default {
	components:{
		xregister
	}
}



// WEBPACK FOOTER //
// ./src/views/register.vue